import { inject, Ref } from 'vue'
import Index from './main.vue'

export default Index

export const InputEditorInjectionKey = 'ellipsis'
export interface EllipsisProvide {
  showDescEllipsis: Ref<boolean>
  descShowWidth: Ref<string>
  showNameEllipsis: Ref<boolean>
  nameShowWidth: Ref<string>
}

export const useInputEditor = () => {
  const provider = inject<EllipsisProvide>(InputEditorInjectionKey)

  if (!provider) {
    throw new Error('No outer <teamHeadProvide /> founded.')
  }

  return provider
}
